import { useEffect, useState } from 'react';
import { getWeekDays, getWeekRange } from 'utils/getWeek';
import { today } from 'components/Form/DateRangePicker/utils';
import useQuality from 'data/hooks/useQuality';
import { HoverRange } from 'data/types/hoverRange';

const useConnect = (brandId: string) => {
  const { quality, isLoading, refetch } = useQuality(brandId);
  const hoverRangeDefault = {
    from: undefined,
    to: undefined,
  };
  const [hoverRange, setHoverRange] = useState<HoverRange>(hoverRangeDefault);
  const [selectedDays, setSelectedDays] = useState<Date[]>(getWeekDays(today));
  const handleDayChange = (date: Date) => {
    const days = getWeekDays(date);
    setSelectedDays(days);
  };
  const handleDayEnter = (date: Date) => {
    const days = getWeekRange(date);
    setHoverRange(days);
  };
  const handleDayLeave = () => {
    setHoverRange(hoverRangeDefault);
  };
  const handleWeekClick = (weekNumber: any, days: Date[]) => {
    setSelectedDays(days);
  };
  useEffect(() => {
    if (brandId !== '') {
      refetch();
    }
  }, [refetch, brandId]);

  const nextCommentPage = async () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(quality);
      }, 1000);
    });
  };

  return {
    hoverRange,
    selectedDays,
    handleDayChange,
    handleDayEnter,
    handleDayLeave,
    handleWeekClick,
    isLoading,
    quality,
    nextCommentPage,
  };
};

export default useConnect;
